/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  decorator.ts
 * @Package :
 * @author:飞算科技
 * @date:   2022/1/19 11:28
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 飞算科技
 * 注意：本内容仅限于飞算数智科技（深圳）有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

// @ts-ignore
import { debounce } from 'lodash'

export function Debounce (time: number) {
  return function (target: any, propertyName: string, propertyDescriptor: PropertyDescriptor): PropertyDescriptor {
    const method = debounce(propertyDescriptor.value, time)
    propertyDescriptor.value = function (...args: any[]) {
      const result = method.apply(this, args)
      // 返回调用函数的结果
      return result
    }
    return propertyDescriptor
  }
}
